import { ProviderManagerSingleton } from './ProviderManagerSingleton';

export function getProviderManager() {
  return ProviderManagerSingleton.getInstance();
}
